module.exports = __webpack_public_path__ + "img/title-label.e4f525a9.png";